/* eslint-disable */
import { Get } from './Get';
import App from './App';
import $ from 'jquery';

export const ExpandableBasket = function (selector) {
  this.init = () => {
    if (!$(selector).length) {
      return;
    }
    this.basketEl = $(selector);
    this.basketProductList = $('#basket__product-list', this.basketEl);
    this.icon = $('.--basket', this.basketEl);
    this.update();
  };

  this.getProductHTML = ({ id, link, icon, name, product_version_name, versions_name, count, worth_unit, prices }) => {
    return /* html */ `<div data-product-id="${id}"  class="basket__block">
                          <div class="basket__item --photo">
                            <a class="photo__link" href="${link}">
                              <img src="${icon}" alt="${name}">
                            </a>
                          </div>
                          <div class="basket__item --name">
                            <div class="basket__name">
                              <div class="basket__product">
                                  <a class="product__link" href="${link}">
                                      <h3 class="product__name">${name}</h3>
                                  </a>
                              </div>
                            </div>
                          </div>
                          <div class="basket__item --price">
                            <div class="basket__price">
                                <span class="basket__sum">${prices.worth_gros_formatted}</span>
                            </div>
                          </div>
                          <div class="basket__item --actions">
                            <div class="basket__action --remove">
                              <a href="/basketchange.php?product=${id}&size=uniw&mode=1&getAjax=true&change=empty" class="basket__remove --click btn --solid --secondary --icon" data-href="/basketchange.php?product=${id}&size=uniw&mode=1&getAjax=true&change=empty">
                                <svg xmlns="http://www.w3.org/2000/svg" width="6.188" height="6.188" viewBox="0 0 6.188 6.188">
                                  <path id="Path_410" data-name="Path 410" d="M4.289-3.375,6.047-1.617a.526.526,0,0,1,.158.387.587.587,0,0,1-.158.4L5.66-.439a.587.587,0,0,1-.4.158.526.526,0,0,1-.387-.158L3.111-2.2,1.354-.439a.526.526,0,0,1-.387.158.587.587,0,0,1-.4-.158L.176-.826a.587.587,0,0,1-.158-.4.526.526,0,0,1,.158-.387L1.934-3.375.176-5.133A.526.526,0,0,1,.018-5.52a.587.587,0,0,1,.158-.4l.387-.387a.587.587,0,0,1,.4-.158.526.526,0,0,1,.387.158L3.111-4.553,4.869-6.311a.526.526,0,0,1,.387-.158.587.587,0,0,1,.4.158l.387.387a.587.587,0,0,1,.158.4.526.526,0,0,1-.158.387Z" transform="translate(-0.018 6.469)"/>
                                </svg>
                              </a>
                            </div>
                          </div>
                      </div>`;
  };

  this.update = async ({ Basket } = {}) => {
    if (!this.basketEl) {
      return;
    }
    this.basketEl.addClass('--loading');
    $('.basket__mid', this.basketProductList).remove();

    const callback = ({ Basket }) => {
      App.vars.Basket = [];
      this.basketEl.removeClass('--loading');

      if (!Basket || Basket.response.basket.products.length === 0) {
        // Basket empty
        this.icon.addClass('--empty');
        this.basketProductList.addClass('--empty');

        return;
      }

      // Basket not empty
      App.vars.Basket = Basket.response.basket;
      this.icon.removeClass('--empty');
      this.basketProductList.removeClass('--empty');

      const { products } = Basket.response.basket;
      const { basket } = Basket.response;

      let product = ``;
      products.forEach((prod) => {
        product += this.getProductHTML(prod);
      });

      const price = basket.worth;
      const shippingLimitFree = +basket.shippingLimitFree;
      const shippingCost = +basket.shippingCost;
      let totalCosts = (price + shippingCost).toFixed(2);
      totalCosts = totalCosts.toString().replace('.', ',');
      const basketWorth = parseFloat(basket.worth);
      const basketWorthFormatted = (basketWorth.toFixed(2) + ' ' + basket.currency_sign).replace('.', ',');

      const midBasket = $('<div/>', {
        class: 'basket__mid',
      }).html(product);
      $('.basket__upper', this.basketEl).after(midBasket);

      $('#worth', this.basketEl).text(basketWorthFormatted);
      $('#shippingCost', this.basketEl).text(
        shippingLimitFree == 0 && shippingCost == 0
          ? window.Literals.dropdownCart.gratis
          : `${shippingCost} ${basket.currency_sign}`,
      );
      $('#totalCost', this.basketEl).text(totalCosts + ' ' + basket.currency_sign);
    };

    if (!Basket) {
      Get.Basket(callback);
      return;
    }

    callback({ Basket });
  };

  this.init();

  return this;
};
